export * from "./apiRoutes";
export * from "./estoqueDaca";
export * from "./httpStatus";
export * from "./map";
export * from "./permissions";
export * from "./prestacaoContas";

/* CONSTANTES GERAIS DO SISTEMA */
export const NUMERO_ITENS_POR_PAGINA = 15;
export const NUMERO_MAX_CARACTERES_LISTAGEM = 40;

export const PATH_LISTAGEM_DOACOES = "/centralDoacoes/listaDoacoes";
export const PATH_LISTAGEM_ENTIDADES = "/centralDoacoes/listaEntidades";
export const PATH_LISTAGEM_OFICIOS = "/centralDoacoes/listaOficios";
export const MAX_LENGTH_SMS = 150;
export const MAX_LENGTH_EMAIL = 10000;

export const LISTA_LINKS_AUDIENCIA = [
	{
		key: 0,
		nome: "INMET - Instituto Nacional de Meteorologia",
		link: "http://www.inmet.gov.br/portal/"
	},
	{
		key: 1,
		nome: "WINDY",
		link: "https://www.windy.com"
	},
	{
		key: 2,
		nome: "SALA DE SITUAÇÃO / SEMA",
		link: "http://www.saladesituacao.rs.gov.br/"
	},
	{
		key: 3,
		nome: "REDEMET",
		link: "https://www.redemet.aer.mil.br"
	},
	{
		key: 4,
		nome: "IDAP",
		link: "http://idap-tv.mi.gov.br/#/auth/login"
	},
	{
		key: 5,
		nome: "AVIATION WEATHER",
		link: "https://www.aviationweather.gov/"
	}
];

export const CUSTOM_EVENTS = {
	UPDATE_USER: "updateUser"
};
